<zn-hierarchical-view
  [rootComponentInstance]="this"
/>

<app-generic-form
  #genericForm
  (payload)="save($event)"
></app-generic-form>